"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9495],{

/***/ 9495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39653);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49801);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29438);
/* harmony import */ var src_containers_GenericModalContainer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12955);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);









const HowNltWorksSectionMobile = _ref => {
  let {
    image,
    imageAlt,
    itemsTitle,
    items,
    description,
    descriptionTitle,
    hrefTitle,
    content
  } = _ref;
  const {
    isOpen,
    onOpen,
    onClose
  } = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .useDisclosure */ .qY)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .VStack */ .gC, {
    spacing: -130,
    align: "stretch",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
      bg: "primaryGreen.800",
      p: "l",
      pb: "8rem",
      pos: "relative",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        mr: "5",
        mb: "7",
        fontSize: "1.5rem",
        lineHeight: "1.938rem",
        children: descriptionTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
        fontFamily: "Montserrat-Medium",
        fontSize: "1rem",
        lineHeight: "1.425rem",
        textAlign: "left",
        color: "baseWhite",
        mt: ".75rem",
        children: description
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
      p: "l",
      zIndex: "2",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: image,
        alt: imageAlt,
        width: "593",
        height: "358",
        objectFit: "contain",
        loading: "lazy",
        decoding: "async",
        className: "rounded"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
      bg: "baseWhite",
      p: "l",
      pt: "8rem",
      textAlign: "left",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        color: "baseDark",
        fontSize: "1.125rem",
        lineHeight: "1.463rem",
        children: itemsTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        items: items,
        color: "baseDark",
        fontSize: "0.875rem"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
        fontFamily: "Montserrat-Medium",
        color: "baseDark",
        onClick: onOpen,
        children: [hrefTitle, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_7__/* .ArrowForwardIcon */ .mr, {})]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_containers_GenericModalContainer__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        isOpen: isOpen,
        onClose: onClose,
        title: content.title,
        children: content.text
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (HowNltWorksSectionMobile);

/***/ })

}]);